import Typography, { TypographyProps } from '@mui/material/Typography';
import { contentTypography } from '../tokens/base/contentStyles';

/** Explicit role avoids tenant heading variants changing the page hierarchy. */
export function PageTitle({ sx, ...props }: Omit<TypographyProps<'h1'>, 'component' | 'variant' | 'ref'>) {
  return <Typography {...props} component="h1" variant="inherit"
    sx={[contentTypography.pageTitle, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]} />;
}
